/**
 * Preserves an invitation identifier while an authentication flow changes route.
 *
 * Invitation acceptance remains server-authorized; this only carries the
 * pending invitation reference until the authenticated handler can redeem it.
 */
export function withInvitationId(path: string, invitationId: string | null): string {
  if (!invitationId) return path

  const url = new URL(path, 'http://localhost')
  url.searchParams.set('invitationId', invitationId)

  return `${url.pathname}${url.search}${url.hash}`
}
